import React, { Component } from 'react';
import styled from 'styled-components';
import FacebookGrey from '../../images/BlogPost/logo_facebook-grey.svg';
import LinkedinGrey from '../../images/BlogPost/logo_linkedin-grey.svg';
import TwitterGrey from '../../images/BlogPost/logo_twitter-grey.svg';
import Facebook from '../../images/BlogPost/logo_facebook.svg';
import Twitter from '../../images/BlogPost/logo_twitter.svg';
import Linkedin from '../../images/BlogPost/logo_linkedin.svg';
import Whatsapp from '../../images/BlogPost/logo_whatsapp.svg';
import LazyImage from '@/components/LazyLoadImage';

const Section = styled.section`
  background-color: ${({ theme }) => theme.colors.white};
  height: 100%;
  margin: 0 auto;
  width: 80%;
  max-width: 680px;
`;

const PostHeader = styled.header`
  display: flex;
  justify-content: space-between;
  font-family: 'Lato', sans-serif;
  color: ${({ theme }) => theme.colors.gray};

  .SocialLinks a:not(:last-child) {
    margin-right: 0.5rem;
  }

  .SocialLinks a {
    transition: 0.3s all linear;
    &:hover {
      opacity: 0.8;
    }
  }
`;
const PostContent = styled.div`
  padding: 1rem 0 2rem 0;
  border-top: 1.5px solid #f2f2f3;
  border-bottom: 1.5px solid #f2f2f3;

  ul,
  ol {
    text-align: left;
  }

  div {
    display: block !important;
    text-align: center;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: 'Lato', sans-serif;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    text-align: left;
    color: ${({ theme }) => theme.colors.gray};
  }

  h1 {
    font-size: 44px;
    line-height: 1.17;
  }

  h2 {
    font-size: 36px;
    line-height: 1.38;
    display: block;
    margin: 3rem 0 1.5rem 0;
  }

  h3 {
    font-size: 28px;
    margin: 1.5rem 0;
  }
  h4 {
    font-size: 24px;
  }
  h5 {
    font-size: 18px;
  }
  h6 {
    font-size: 16px;
  }

  p {
    letter-spacing: 0.51px;
    line-height: 30px;
    font-size: 1.1rem;
    text-align: left;
    font-family: 'Lato', sans-serif;
    color: ${({ theme }) => theme.colors.gray};
    margin: 1rem 0;
  }

  a {
    color: ${({ theme }) => theme.colors.green};
  }

  ul,
  ol {
    display: block;
  }

  ul {
    margin: 1rem 0;
    list-style: none;
  }

  ol {
    list-style: decimal inside;
  }

  ul li {
    display: block;
    color: ${({ theme }) => theme.colors.gray};
    font-size: 16px;
    padding-left: 20px;
    position: relative;
    line-height: 32px;
  }

  ol li {
    color: ${({ theme }) => theme.colors.gray};
    font-size: 16px;
    line-height: 32px;
  }

  ul li::before {
    position: absolute;
    content: '';
    width: 8px;
    height: 8px;
    left: 0;
    top: 12px;
    border-radius: 4px;
    background: ${({ theme }) => theme.colors.green};
  }

  table,
  blockquote {
    color: ${({ theme }) => theme.colors.gray};
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    margin: 0;
  }

  blockquote {
    padding: 20px;
    background: rgba(0, 0, 0, 0.04);
  }

  blockquote p {
    margin: 6px 0;
  }

  table thead th {
    font-weight: 500;
    padding: 8px;
    background: rgba(0, 0, 0, 0.1);
  }

  table td {
    font-size: 14px;
    padding: 8px;
    background: rgba(0, 0, 0, 0.06);
  }

  img,
  iframe {
    max-width: 100%;
  }

  img {
    object-fit: contain;
  }
`;
const ShareComponent = styled.div`
  width: 210px;
  padding: 2rem 0;
  h2 {
    font-family: 'Lato', sans-serif;
    font-size: 1rem;
    line-height: 1.5rem;
    color: ${({ theme }) => theme.colors.gray};
    font-weight: 500;
    letter-spacing: 0.51px;
  }

  ul {
    margin-top: 1rem;
    display: flex;
    justify-content: space-between;
    li {
      list-style: none;

      a {
        transition: 0.3 all linear;
        &:hover {
          opacity: 0.8;
        }
      }
    }
  }
`;

class PostContentSection extends Component {
  render() {
    const { children, pageContext } = this.props;

    return (
      <Section>
        <PostHeader>
          <div>
            <p>
              {pageContext.date} {pageContext.update_date && `(atualizado em ${pageContext.update_date})`}
            </p>
          </div>
          <div className="SocialLinks">
            <a
              href={`https://www.facebook.com/sharer/sharer.php?u=${this.props.location}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <LazyImage src={FacebookGrey} alt="Logo Facebook" />
            </a>
            <a
              href={`https://www.linkedin.com/shareArticle?mini=true&url=${this.props.location}&title=${pageContext.title}&summary=${pageContext.description}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <LazyImage src={LinkedinGrey} alt="Logo Linkedin" />
            </a>
            <a
              href={`https://twitter.com/intent/tweet?url=${this.props.location}&text=${pageContext.title}&via=Pagar_me`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <LazyImage src={TwitterGrey} alt="Logo Twitter" />
            </a>
          </div>
        </PostHeader>
        <PostContent>{children}</PostContent>
        <ShareComponent>
          <h2>Compartilhe esse conteúdo</h2>
          <ul>
            <li>
              <a
                href={`https://www.facebook.com/sharer/sharer.php?u=${this.props.location}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <LazyImage src={Facebook} alt="Logo Facebook colorido" />
              </a>
            </li>
            <li>
              <a
                href={`https://www.linkedin.com/shareArticle?mini=true&url=${this.props.location}&title=${pageContext.title}&summary=${pageContext.description}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <LazyImage src={Linkedin} alt="Logo Linkedin colorido" />
              </a>
            </li>
            <li>
              <a
                href={`https://twitter.com/intent/tweet?url=${this.props.location}&text=${pageContext.title}&via=Pagar_me`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <LazyImage src={Twitter} alt="Logo Twitter colorido" />
              </a>
            </li>
            <li>
              <a href={`whatsapp://send?text=${this.props.location}`} target="_blank" rel="noopener noreferrer">
                <LazyImage src={Whatsapp} alt="Logo Whatsapp Colorido" />
              </a>
            </li>
          </ul>
        </ShareComponent>
      </Section>
    );
  }
}

export default PostContentSection;
